import "core-js/modules/es6.object.freeze.js";
import "core-js/modules/es6.string.link.js";
import "core-js/modules/es6.function.name.js";
import _first from "lodash/first";
import _get from "lodash/get";
import _last from "lodash/last";

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n  fragment getAboutSchema on PostInterface {\n    __typename\n    ... on Article {\n      categories {\n        name\n      }\n    }\n    ... on Roundup {\n      categories {\n        name\n      }\n    }\n  }\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n  fragment getEditorSchema on Article {\n    __typename\n    assigningEditor {\n      id\n      name\n      link\n      avatarUrls(sizes: [SIZE_96]) {\n        size\n        url\n      }\n      alumniOf\n      affiliation\n      award\n      honorificSuffix\n      jobTitle\n      specialties\n    }\n  }\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  fragment getAuthorSchema on PostWithAuthorsInterface {\n    __typename\n    authors {\n      id\n      name\n      link\n      avatarUrls {\n        size\n        url\n      }\n      alumniOf\n      affiliation\n      award\n      honorificSuffix\n      jobTitle\n      specialties\n    }\n  }\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  fragment getReviewerSchema on PostWithReviewerInterface {\n    __typename\n    reviewedBy {\n      id\n      name\n      link\n      honorificSuffix\n      jobTitle\n      knowsAbout\n      alumniOf\n      featuredMedia {\n        id\n        croppedImages(sizes: [SQUARE_350, SQUARE_160, SQUARE]) {\n          sourceUrl\n        }\n      }\n    }\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

import { gql } from '@nerdwallet/apollo';
import { getAuthors, getReviewers } from '@nerdwallet/wp-api/selectors/common';
import { NERDWALLET_AUTHOR_ID, ORGANIZATION } from '../../constants';
/*
 * Get the schema for ContentReviewer
 *
 * @param  {Object} post WordPress post object
 *
 * @return {Object} ContentReviewer schema
 */

export var getReviewerSchema = function getReviewerSchema(post) {
  // eslint-disable-next-line no-underscore-dangle, no-use-before-define
  if (post.__typename) return getReviewerSchemaGql(post);
  var reviewers = getReviewers(post);
  var primaryReviewer = reviewers[0]; // only include the primary reviewer

  if (!primaryReviewer) return undefined;
  var reviewerSchema = {
    '@type': 'Person',
    name: primaryReviewer.nw_data.name,
    sameAs: primaryReviewer.link,
    honorificSuffix: primaryReviewer.nw_data.honorific_suffix,
    jobTitle: primaryReviewer.nw_data.job_title,
    knowsAbout: primaryReviewer.nw_data.knows_about
  };

  if (primaryReviewer.nw_data.alumni_of) {
    reviewerSchema.alumniOf = {
      '@type': 'EducationalOrganization',
      name: _last(primaryReviewer.nw_data.alumni_of)
    };
  }

  return reviewerSchema;
};
getReviewerSchema.fragment = gql(_templateObject());
/*
 * Get the schema for Author
 *
 * @param  {Object} post WordPress post object
 *
 * @return {Object} Author schema
 */

export var getAuthorSchema = function getAuthorSchema(post) {
  // eslint-disable-next-line no-underscore-dangle, no-use-before-define
  if (post.__typename) return getAuthorSchemaGql(post);
  var authorSchema = {};
  var authors = getAuthors(post);
  var primaryAuthor = authors[0]; // only include the primary author

  if (primaryAuthor) {
    if (primaryAuthor.id === NERDWALLET_AUTHOR_ID) {
      // NerdWallet
      authorSchema = {
        '@id': ORGANIZATION['@id']
      };
    } else {
      authorSchema = {
        '@type': 'Person',
        image: _get(primaryAuthor, 'avatar_urls[96]'),
        name: primaryAuthor.name,
        sameAs: primaryAuthor.link,
        award: primaryAuthor.nw_user_award,
        honorificSuffix: primaryAuthor.nw_user_honorific_suffix,
        jobTitle: primaryAuthor.nw_user_job_title,
        knowsAbout: primaryAuthor.nw_user_specialties
      };

      if (primaryAuthor.nw_user_affiliation) {
        authorSchema.affiliation = {
          '@type': 'Organization',
          name: primaryAuthor.nw_user_affiliation
        };
      }

      if (primaryAuthor.nw_user_alumni_of) {
        authorSchema.alumniOf = {
          '@type': 'EducationalOrganization',
          name: primaryAuthor.nw_user_alumni_of
        };
      }
    }
  }

  return authorSchema;
};
getAuthorSchema.fragment = gql(_templateObject2());
/*
 * Get the schema for a Person
 *
 * @param  {Object} person query0 person object
 *
 * @return {Object} Person schema
 */

var getPersonSchemaGql = function getPersonSchemaGql(person) {
  var _last$url, _last2, _first2, _person$featuredMedia, _person$specialties;

  var personSchema = {};

  if (!person) {
    return personSchema;
  }

  if (person.id === NERDWALLET_AUTHOR_ID) {
    // NerdWallet
    return {
      '@id': ORGANIZATION['@id']
    };
  }

  personSchema = {
    '@type': 'Person',
    image: (_last$url = (_last2 = _last(person.avatarUrls)) === null || _last2 === void 0 ? void 0 : _last2.url) !== null && _last$url !== void 0 ? _last$url : (_first2 = _first((_person$featuredMedia = person.featuredMedia) === null || _person$featuredMedia === void 0 ? void 0 : _person$featuredMedia.croppedImages)) === null || _first2 === void 0 ? void 0 : _first2.sourceUrl,
    name: person.name,
    sameAs: person.link,
    award: person.award,
    honorificSuffix: person.honorificSuffix,
    jobTitle: person.jobTitle,
    knowsAbout: (_person$specialties = person.specialties) !== null && _person$specialties !== void 0 ? _person$specialties : person.knowsAbout
  };

  if (person.affiliation) {
    personSchema.affiliation = {
      '@type': 'Organization',
      name: person.affiliation
    };
  }

  if (person.alumniOf) {
    personSchema.alumniOf = {
      '@type': 'EducationalOrganization',
      name: person.alumniOf
    };
  }

  return personSchema;
};
/*
 * Get the schema for Author
 *
 * @param  {Object} post query0 post object
 *
 * @return {Object} Author schema
 */


var getAuthorSchemaGql = function getAuthorSchemaGql(post) {
  var _post$authors;

  var authors = (_post$authors = post === null || post === void 0 ? void 0 : post.authors) !== null && _post$authors !== void 0 ? _post$authors : [];
  var primaryAuthor = authors[0]; // only include the primary author

  return getPersonSchemaGql(primaryAuthor);
};
/*
 * Get the schema for ContentReviewer
 *
 * @param  {Object} post query0 post object
 *
 * @return {Object} ContentReviewer schema
 */


var getReviewerSchemaGql = function getReviewerSchemaGql(post) {
  var _post$reviewedBy;

  var reviewers = (_post$reviewedBy = post === null || post === void 0 ? void 0 : post.reviewedBy) !== null && _post$reviewedBy !== void 0 ? _post$reviewedBy : [];
  var primaryReviewer = reviewers[0];
  return getPersonSchemaGql(primaryReviewer);
};
/*
 * Get the schema for Editor
 *
 * @param  {Object} post query0 post object
 *
 * @return {Object} Editor schema
 */


export var getEditorSchema = function getEditorSchema(post) {
  var editor = post === null || post === void 0 ? void 0 : post.assigningEditor;
  return getPersonSchemaGql(editor);
};
getEditorSchema.fragment = gql(_templateObject3());
/**
 * Get about schema for categories
 *
 * @param  {Array} categories array
 *
 * @return {Array} categories with mapped schema array
 */

export var getAboutSchema = function getAboutSchema(categories) {
  // eslint-disable-next-line no-use-before-define, no-underscore-dangle
  if (categories.__typename) return getAboutSchemaGql(categories);
  return categories.map(function (category) {
    return {
      '@type': 'Thing',
      name: _get(category, 'name')
    };
  });
};
getAboutSchema.fragment = gql(_templateObject4());
/**
 * Get about schema for categories
 *
 * @param  {Object} post query0 object
 *
 * @return {Array} categories with mapped schema array
 */

var getAboutSchemaGql = function getAboutSchemaGql(post) {
  var _post$categories;

  return ((_post$categories = post === null || post === void 0 ? void 0 : post.categories) !== null && _post$categories !== void 0 ? _post$categories : []).map(function (category) {
    return {
      '@type': 'Thing',
      name: category === null || category === void 0 ? void 0 : category.name
    };
  });
};